import { useEffect, useState } from 'react';
import { calculateTimeLeft } from '../utils/timeUtils/calculateTimeLeft';

type UseTimerReturn = {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
  isTimeOver: boolean;
};
/**
 * use in smollest component to avoid rerender all component every second
 */
export const useTimer = (expirationEpoch: number): UseTimerReturn => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(expirationEpoch));

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(expirationEpoch));
    }, 1000);
    return () => clearTimeout(timer);
  });

  return {
    days: timeLeft.days.toString().padStart(2, '0'),
    hours: timeLeft.hours.toString().padStart(2, '0'),
    minutes: timeLeft.minutes.toString().padStart(2, '0'),
    seconds: timeLeft.seconds.toString().padStart(2, '0'),
    isTimeOver: timeLeft.difference <= 0,
  };
};
